import { render, staticRenderFns } from "./SupplierPerformanceDialog.vue?vue&type=template&id=c7a17b36&scoped=true&"
import script from "./SupplierPerformanceDialog.vue?vue&type=script&lang=js&"
export * from "./SupplierPerformanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a17b36",
  null
  
)

export default component.exports